/* «عرض سريع» on a product card.

   Clicking anywhere else on a card already opens the product's own page, so a
   second button that does the same thing is a wasted line. It opens Horizon's
   quick-add dialog instead — which is not really an add-to-cart dialog at all:
   it fetches the product page and puts its whole `product-component` inside a
   modal, so the shopper gets the photograph, the name, the price and the buy
   buttons without leaving the grid they were reading.

   Nothing new is built here. Every card already carries a hidden
   `<quick-add-component>` — the theme renders it for the single-variant "Add"
   path and 'elshrouk-cards' hides it — and that element owns the fetch, the
   cache and the dialog. Its `handleClick` is a public field, so this listener
   only has to find it and hand it the event.

   The click is caught in the capture phase and stopped there. The dialog
   closes itself on a click outside its panel, and a click that is allowed to
   carry on bubbling reaches that listener a moment after the fetch resolves —
   the modal opens and shuts in the same frame. That is the whole reason for
   the `true` at the end.

   The button stays a real <a href> to the product. If this script never loads,
   or the dialog is missing because quick add was switched off in the theme
   settings, the link is left alone and does what it always did.
*/
(function () {
  document.addEventListener(
    'click',
    function (event) {
      if (event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey) return;

      var trigger = event.target.closest ? event.target.closest('.es-card__view') : null;
      if (!trigger) return;

      if (!document.getElementById('quick-add-dialog')) return;

      var card = trigger.closest('product-card');
      var quickAdd = card && card.querySelector('quick-add-component');
      if (!quickAdd || typeof quickAdd.handleClick !== 'function') return;

      event.preventDefault();
      event.stopPropagation();
      quickAdd.handleClick(event);
    },
    true
  );
})();
